// Single source of truth for brand identity. Change it here once and it
// propagates to the header, sidebar, footer, document/PDF footers, SEO meta and JSON-LD.
export const BRAND = {
  name: "חשבית",
  nameEn: "Heshbit",

  // Wordmark split — the middle letter ב carries a green "dagesh" dot.
  // Logical order of "חשבית": ח ש ב י ת  →  before="חש", dot="ב", after="ית".
  wordmark: { before: "חש", dot: "ב", after: "ית" },

  // Brand color for the dagesh dot (green — accounting/online/WhatsApp vibe).
  dotColor: "#22c55e",

  // Messaging
  slogan: "מנהלת החשבוניות הדיגיטליות שלך",
  campaignLine: "שלח הודעה, חשבית מוציאה חשבונית",

  url: "https://heshbit.co.il",
  domain: "heshbit.co.il",
  email: "support@heshbit.co.il",
  // שם השולח שמופיע במיילים יוצאים (חשבוניות/קבלות) — ממותג חשבית ותואם לדומיין
  // השליחה (מפחית סיכוי לספאם). שם העסק עצמו מופיע בנושא ובגוף, ותשובות חוזרות אליו.
  emailSenderName: "חשבית · הפקת חשבוניות",
  phone: "", // set a real number to show it in the footer

  // SEO defaults — tuned for strong Israeli organic search
  // (עד ~60 תווים בכותרת ו-~155 בתיאור — מעבר לזה גוגל חותך. להחליף גם ב-index.html)
  defaultTitle: "חשבית — הפקת חשבוניות וקבלות אונליין לעסק הישראלי",
  description:
    "הפיקו חשבונית ירוקה (דיגיטלית), קבלה, דרישת תשלום והצעת מחיר תוך שניות — גם מהוואטסאפ. תואם רשות המסים, עם חתימה דיגיטלית ומספרי הקצאה. התחילו בחינם.",
  // ?v=2 — עוקף את ה-cache של סורקי וואטסאפ/פייסבוק אחרי תיקון הכרטיס (טקסט חתוך + 728KB→23KB).
  ogImage: "https://heshbit.co.il/og-image.png?v=2",
  locale: "he_IL",
};

export default BRAND;
